import { useEffect, useState } from "react";
import { twMerge } from "tailwind-merge";

// Interfaces
import { IControlledDialog, IControlledDialogActions } from "./interfaces.ts";

// Layouts
import Button from "@/Layouts/components/Buttons/Button";

// Components
import DialogExtension from "./DialogExtension";

// MUI
import { Skeleton, Stack } from "@mui/material";

const actionsInterceptor = (actions: IControlledDialogActions[], onActionIntercept = () => {}) => {
	if (!actions?.length) {
		return [];
	}
	return actions.map((action) => {
		if (action?.shouldCloseDialog) {
			return {
				...action,
				onClickAction: () => {
					onActionIntercept?.();
					action.onClickAction?.();
				},
			};
		}
		return action;
	});
};

export default function ControlledDialog(props: Readonly<IControlledDialog>) {
	const {
		classes = "h-[30px] !rounded-[6px] !font-sans",
		bgColor,
		content = null,
		title = "Open Dialog",
		loadingPosition = "center",
		disabled = false,
		loading = false,
		fetching = false,
		endIcon = null,
		sx = null,
		dialogProperties = {},
		loadingProperties = {},
		onClickAction = () => {},
		onCloseAction = () => {},
	} = props ?? {};

	const [open, setOpen] = useState(false);

	const handleOpenDialog = () => {
		if (disabled) {
			return;
		}
		setOpen(true);
		onClickAction?.();
	};

	const handleCloseDialog = () => {
		setOpen(false);
		onCloseAction?.();
	};

	useEffect(() => {
		return () => {
			setOpen(false);
		};
	}, []);

	const isButtonDisabled = disabled || loading || fetching;
	return (
		<Stack>
			<DialogExtension
				open={open}
				onCloseAction={handleCloseDialog}
				{...dialogProperties}
				actions={actionsInterceptor(dialogProperties?.["actions" as keyof object], handleCloseDialog)}
			>
				{content}
			</DialogExtension>
			<Stack justifyContent={"center"}>
				{loading ? (
					<Skeleton variant="rectangular" width={132} height={30} sx={{ borderRadius: "6px" }} {...loadingProperties} />
				) : (
					<Button
						variant="contained"
						text={title}
						classes={twMerge("h-[30px] !rounded-[6px] !font-sans", classes)}
						bgColor={bgColor}
						endIcon={endIcon}
						loadingPosition={loadingPosition}
						disabled={isButtonDisabled}
						loading={fetching}
						sx={{ ...sx, textTransform: "unset !important" }}
						onClick={handleOpenDialog}
					/>
				)}
			</Stack>
		</Stack>
	);
}
